import url from './url';



export default url(({ userId = ':userId' }) => `/rbac/users/${userId}`);
